module.exports = __webpack_public_path__ + "static/media/section-three@2x.15b88b1f.png";